module Dashboard {
    "use strict";

    export function widgetTimeRangeDirective(): ng.IDirective {
        return {
            restrict: "EA",
            scope: true,
            bindToController: {
                config: "="
            },
            templateUrl: "widgetTimeRangeTemplate.htm",
            controller: "widgetTimeRangeController as ctrl"
        }
    }
    module.directive("frendsWidgetTimeRange", [widgetTimeRangeDirective]);

    export class WidgetTimeRangeController {
        public config: IWidgetConfigWithTimeRange;
        public ranges: number[];

        static $inject = [];
        constructor() {
            this.ranges = [1,3,7,30];
        }

        public setRange(range) {
            this.config.rangeInDays = range;
        }

        public isSelected(value) {
            return (value === this.config.rangeInDays) ? "selected" : "";
        }
    }
    module.controller("widgetTimeRangeController", WidgetTimeRangeController);
}